"use strict";
/**
 * QVET Warehouses
 *
 * Physical warehouse locations in QVET system.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WAREHOUSES = void 0;
exports.WAREHOUSES = ['HARBOR', 'MONTEJO', 'URBAN CENTER'];
